

import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from '@angular/material/icon';
import { PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent, MatTabsModule } from "@angular/material/tabs";
import { finalize, Subject } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { GestioneCrawlingService } from '../../services/gestione-crawling.service';
import { NotificationService } from '../../services/notification.service';
import { DateRangeFilter, DateRangeFilterComponent } from "../../shared/date-range-filter/date-range-filter.component";
import { SearchBarComponent } from "../../shared/searchbar/searchbar.component";
import { SharedTableComponent } from "../../shared/shared-table/shared-table.component";

@Component({
  selector: 'app-crawling-json',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressBarModule, MatSnackBarModule, MatIconModule, SharedTableComponent, MatTabsModule, MatCardModule, SearchBarComponent, DateRangeFilterComponent],
  templateUrl: './crawling-json.component.html',
  styleUrl: './crawling-json.component.scss'
})
export class CrawlingJsonComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChildren('filter') filters!: QueryList<any>;

  currentTenant = '';

  fileName = '';
  isUploading = false; 
  isHovering = false;   
  
  activeTab: string = '';
  isLoading = false;
  hasError = false;

  // Paginazione ed ordinamento (server-side)
  
  sort = 'name';
  direction = 'asc';
  sortBy: string = '';
  sortKentico = 'date';
  directionKentico = 'desc';
  kenticoSortBy: string = '';
  pageIndex = 0;
  pageSize = 10;
  totalItems = 0;

  // filtro logs json e xml
  uploadedFilesFilter = {
    endDate: null as string | null,
    requireJson: true,
    search: '',
    startDate: null as string | null
  };

  // filtro logs kentico
  kenticoHistoryFilter = {
     endDate: null as string | null,
     startDate: null as string | null,
     documentId: '',
     status: ''
  }


  filterFieldsKentico: string[] = ["documentId"];
  filterMapKentico: Record<string, string[]> = { documentId: ["IDdocument"] };
  filterLabelsKentico: Record<string, string[]> = { documentId: ["ID documento"] };
  filterFields: string[] = ["name"];
  filterMap: Record<string, string[]> = { name: ["name"] };
  filterLabels: Record<string, string[]> = { name: ["nome"] };

  // DataSource tabella Logs
  dataSourceLogs = new MatTableDataSource();
  
  dataSourceKenticoLogs = new MatTableDataSource<any>();

  logsList$ = new Subject<void>();

  constructor(
    private readonly crawlingService: GestioneCrawlingService,
    private readonly snackBar: MatSnackBar,
    private readonly auth: AuthenticationService,
    private readonly notificationService: NotificationService
  ) {}


  ngOnInit(): void {
    this.activeTab = 'upload';
    this.currentTenant = this.auth.getTenant();
  }


  onTabChanged(event: MatTabChangeEvent){
    switch(event.index){
      case 0: 
        this.activeTab = 'upload';
        break;
      case 1:
        this.activeTab = 'monitoringJSON';
        break;
      case 2:
        this.activeTab = 'monitoringXML';
        break;
      case 3:
        this.activeTab = 'monitoringKentico';
        break;
      default:
        this.activeTab = '';
    }

    if(this.activeTab === 'monitoringJSON'){
      this.uploadedFilesFilter.requireJson = true;
      this.uploadedFilesFilter.endDate = null;
      this.uploadedFilesFilter.startDate = null;
      this.uploadedFilesFilter.search = '';
      this.kenticoHistoryFilter.documentId = '';
      this.kenticoHistoryFilter.status = '';
      this.kenticoHistoryFilter.endDate = null;
      this.kenticoHistoryFilter.startDate = null;
      this.fileName = '';
      this.filters.forEach(f => f.reset());
      console.log('filtro json', this.uploadedFilesFilter);
    } else if(this.activeTab === 'monitoringXML'){
      this.uploadedFilesFilter.requireJson = false;
      this.uploadedFilesFilter.endDate = null;
      this.uploadedFilesFilter.startDate = null;
      this.uploadedFilesFilter.search = '';
      this.kenticoHistoryFilter.documentId = '';
      this.kenticoHistoryFilter.status = '';
      this.kenticoHistoryFilter.endDate = null;
      this.kenticoHistoryFilter.startDate = null;
      console.log('file caricato', this.fileName);
      this.fileName = '';
      this.filters.forEach(f => f.reset());
      console.log('filtro xml', this.uploadedFilesFilter);
    } else if(this.activeTab === 'monitoringKentico'){
      this.uploadedFilesFilter.requireJson = false;
      this.uploadedFilesFilter.endDate = null;
      this.uploadedFilesFilter.startDate = null;
      this.uploadedFilesFilter.search = '';
      this.kenticoHistoryFilter.documentId = '';
      this.kenticoHistoryFilter.status = '';
      this.kenticoHistoryFilter.endDate = null;
      this.kenticoHistoryFilter.startDate = null;
      console.log('file caricato', this.fileName);
      this.fileName = '';
      this.filters.forEach(f => f.reset());
      console.log('filtro kentico', this.dataSourceKenticoLogs);
      this.loadKenticoList(this.pageIndex, this.pageSize, this.kenticoSortBy, this.kenticoHistoryFilter);
      return;
    }

    if(this.activeTab !== 'monitoringKentico'){
      this.loadLogsList(this.pageIndex, this.pageSize, this.sortBy, this.uploadedFilesFilter);
    }
  }

  loadLogsList(pageIndex: number, pageSize: number, sortBy: string, uploadedFilesFilter: any) {
      console.log('chiamata principale siamo nel tab', this.activeTab )
      this.isLoading = true;
      this.hasError = false;
      this.crawlingService.getCrawlingLogFiles(pageIndex, pageSize, sortBy, uploadedFilesFilter).pipe(finalize(() => { 
        this.isLoading = false;
        this.logsList$.next();
       })).subscribe({
        next: (response) => {
          const content = response?.content ?? [];
          this.dataSourceLogs.data = content;
          this.totalItems = response?.totalElements ?? 0;
          this.pageIndex = (response?.number ?? pageIndex) ?? 0;
          this.pageSize  = (response?.size ?? pageSize) ?? this.pageSize;
        },
        error: (err) => {
          console.log('errore nel recupero dei dati', err);
          this.dataSourceLogs.data = [];
          this.totalItems = 0;
          this.hasError = true;
        }
      });
    }

    loadKenticoList(pageIndex: number, pageSize: number, sortBy: string, kenticoHistoryFilter: any) {
      console.log('chiamata principale siamo nel tab', this.activeTab )
      this.isLoading = true;
      this.hasError = false;
      this.crawlingService.getKenticoFiles(pageIndex, pageSize, sortBy, kenticoHistoryFilter).pipe(finalize(() => { 
        this.isLoading = false;
        this.logsList$.next();
       })).subscribe({
        next: (response) => {
          const content = response?.content ?? [];
          this.dataSourceKenticoLogs.data = content;
          this.totalItems = response?.totalElements ?? 0;
          this.pageIndex = (response?.number ?? pageIndex) ?? 0;
          this.pageSize  = (response?.size ?? pageSize) ?? this.pageSize;
        },
        error: (err) => {
          console.log('errore nel recupero dei dati', err);
          this.dataSourceKenticoLogs.data = [];
          this.totalItems = 0;
          this.hasError = true;
        }
      });
    }

  // Cambio pagina / page size
  onPageChanged(ev: PageEvent) {
    this.pageIndex = ev.pageIndex;
    this.pageSize  = ev.pageSize;
    this.loadLogsList(this.pageIndex, this.pageSize, this.sortBy, this.uploadedFilesFilter);
  }

  onPageChangedKentico(ev: PageEvent){
    this.pageIndex = ev.pageIndex;
    this.pageSize  = ev.pageSize;
    console.log('evento pagina', ev);
    this.loadKenticoList(this.pageIndex, this.pageSize, this.kenticoSortBy, this.kenticoHistoryFilter);
  }

  // Ordinamento
  onSortChanged(sort: Sort) {
    this.sort = sort.active;
    this.direction = sort.direction || 'asc';
    this.sortBy = `${this.sort}:${this.direction}`;
    console.log('sorting', this.sortBy);
    this.pageIndex = 0;
    this.loadLogsList(this.pageIndex, this.pageSize, this.sortBy, this.uploadedFilesFilter);
  }

  onSortChangedKentico(sort: Sort) {
    this.sortKentico = sort.active;
    this.directionKentico = sort.direction || 'asc';
    this.kenticoSortBy = `${this.sortKentico}:${this.directionKentico}`;
    console.log('sorting', this.kenticoSortBy);
    this.pageIndex = 0;
    this.loadKenticoList(this.pageIndex, this.pageSize, this.kenticoSortBy, this.kenticoHistoryFilter);
  }

  // ===== Filtro (da search-bar) =====
  onFilterChanged(filters: Record<string, string>): void {
    console.log('siamo nel tab', this.activeTab); //non c'è bisogno di rimettere l'assegnazione di requireJSON, già la prende una volta nel tab
    
    const search = (filters["name"] ?? "").toString();
    if(search === this.uploadedFilesFilter.search) return;

    this.uploadedFilesFilter.search = search;
    console.log('cambio filtro', this.uploadedFilesFilter);
    this.pageIndex = 0; // riparti dalla prima pagina
    this.loadLogsList(this.pageIndex, this.pageSize, this.sortBy, this.uploadedFilesFilter);
  }

  onFilterChangedKentico(filters: Record<string, string>){
    console.log('filtri', filters);
    const search = (filters["documentId"] ?? "").toString();
    if(search === this.kenticoHistoryFilter.documentId) return;

    this.kenticoHistoryFilter.documentId = search;
    console.log('cambio filtro', this.kenticoHistoryFilter);
    this.pageIndex = 0; // riparti dalla prima pagina
    
    this.loadKenticoList(this.pageIndex, this.pageSize, this.kenticoSortBy, this.kenticoHistoryFilter);
    
  }

  onDateFilterChange(filter: DateRangeFilter) {
    if(this.activeTab !== 'monitoringKentico'){
      
      this.uploadedFilesFilter.startDate = filter.startDate ? filter.startDate.toISOString() : null;
      this.uploadedFilesFilter.endDate = filter.endDate ? filter.endDate.toISOString() : null;

      console.log('filtro', filter);
      this.pageIndex = 0;
      this.loadLogsList(this.pageIndex, this.pageSize, this.sortBy, this.uploadedFilesFilter);
    } else {
      
      this.kenticoHistoryFilter.endDate = filter.endDate ? filter.endDate.toISOString() : null;
      this.kenticoHistoryFilter.startDate = filter.startDate ? filter.startDate.toISOString() : null;
      
      this.pageIndex = 0;
      this.loadKenticoList(this.pageIndex, this.pageSize, this.kenticoSortBy, this.kenticoHistoryFilter);
    }
    
  }
  
  canDoActions(role: string): boolean {
    return this.auth.hasRole(role);
  }

  // Apre il file picker 
  openFileDialog(): void {
    this.fileInput?.nativeElement.click();
  }

  // Selezione da file picker
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    this.handleFiles(input.files);
    input.value = ''; // reset per consentire stessa selezione consecutiva
  }

  // Drag over: abilita stile e previene default
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isHovering = true;
  }

  // Drag leave: rimuove stile
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isHovering = false;
  }

  // Drop: prende i file e li passa alla pipeline
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isHovering = false;

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;
    this.handleFiles(files);
  }

  // Valida estensione e avvia upload del primo file (singolo)
  private handleFiles(fileList: FileList): void {
    const file = fileList.item(0);
    if (!file) return;

    const valid = /\.json$/i.test(file.name) || /\.xml$/i.test(file.name);
    if (!valid) {
      this.snackBar.open('Formato non valido. Carica un file .json oppure .xml', 'Chiudi', {
        duration: 3000,
        panelClass: ['snackbar-error']
      });
      return;
    }

    this.fileName = file.name;
    this.uploadFile(file);
  }

  // Upload
  private uploadFile(file: File): void {
    const formData = new FormData();
    formData.append('document', file);

    this.isUploading = true;

    this.crawlingService.uploadCrawlingDocuments(formData).subscribe({
      next: (response) => {
        console.log('Upload riuscito', response);
        this.isUploading = false;
        this.snackBar.open(`Upload del file ${file.name} completato con successo`, 'Chiudi', {
          duration: 3000,
          panelClass: ['snackbar-success']
        });
      },
      error: (err) => {
        console.error('Errore upload', err);
        this.isUploading = false;
        this.snackBar.open(`Errore durante il caricamento del file: ${file.name}`, 'Chiudi', {
          duration: 3000,
          panelClass: ['snackbar-error']
        });
      }
    });
  }

  private downloadAndSaveFile(blob: Blob, fileName: string){

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url); 
  }

  downloadFile(file: any){
    console.log('file',file);
    const fileName = file.name;
    this.isLoading = true;
    this.crawlingService.downloadJSONorXML(fileName).pipe(finalize(() => { 
        this.isLoading = false;
       })).subscribe({
        next: (blob: Blob) => { 
          this.downloadAndSaveFile(blob, fileName);
          this.notificationService.successOnDownload(fileName);
        },
        error: (err)=> {
          console.log("errore nella richiesta", err);
          this.notificationService.errorOnDownload(fileName);
        }
       })

  }



  ngOnDestroy(): void {
    this.logsList$.complete();
  }
}